// a library to wrap and simplify api calls
import axios from 'axios'

let serverUrlInput = false
const serverUrlEl = document.getElementById('serverUrl')
if (serverUrlEl) {
  serverUrlInput = serverUrlEl.value
}

export const serverUrl = serverUrlInput ? serverUrlInput : API_LINK

// const tokenElement = document.getElementById('token')
// const token = tokenElement.value
// tokenElement.parentNode.removeChild(tokenElement)

// our "constructor"
const api = axios.create({
  baseURL: `${serverUrl}`,
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
  },
})

const setHeader = (name, value) => {
  if (value) {
    api.defaults.headers.common[name] = value
  } else {
    delete api.defaults.headers.common[name]
  }
}

const endpoints = {

  // post
  sendSms: (phone) => api.post(`/car-valuation/send-sms/${phone}`),
  getCarValuationFromVin: (data, code, accessories: Array<string> = []) => {
    const url = `/car-valuation/valuate${code}?vehicleId=${escape(data.vehicleId)}&registrationDate=${escape(data.registrationDate)}`
    return api.post(`${url}${data.mileage ? `&mileage=${escape(data.mileage)}` : ''}`, accessories)
  },

  // put

  // get
  getCarInfoFromVin: (vin, code) => api.get(`/car-valuation/get-info/${vin}${code}`),
  getCarIdentificationFromVin: (vin, code) => api.get(`/car-valuation/identify/${vin}${code}`),
  getCarWindscreenFromVin: (vin, code) => api.get(`/car-valuation/get-windscreen/${vin}`),
  getCarVinFromRz: (rz) => api.get(`/car-valuation/reg-plate-to-vin/${rz}`),

  // delete

  // helpers
  serverUrl,
  setHeader
}

export default endpoints
